export const calculateTime = (timestamp) => {
  // Check if timestamp is in ISO 8601 format
  const iso8601Format =
    /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{6}\+\d{2}:\d{2}/;
  if (iso8601Format.test(timestamp)) {
    // Convert timestamp to unix
    timestamp = new Date(timestamp).getTime() / 1000;
  }

  const date = new Date(timestamp * 1000);
  const now = new Date();
  const diffInSeconds = Math.abs(now - date) / 1000;
  const diffInHours = diffInSeconds / 3600;

  if (diffInHours < 24) {
    const diffInMinutes = diffInSeconds / 60;
    return diffInHours < 1
      ? `${Math.round(diffInMinutes)} mins`
      : `${Math.round(diffInHours)} hrs`;
  } else {
    const options = { month: "short", day: "numeric" };
    return date.toLocaleDateString(undefined, options);
  }
};

export const classNames = (...classes) => {
  return classes.filter(Boolean).join(" ");
};
